module.exports = __webpack_public_path__ + "img/vip-coupon.c0b37526.png";